var React = require('react');

function PhoneEmpty (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.249 24a6.686 6.686 0 01-2.294-.41 24.462 24.462 0 01-8.883-5.662A24.46 24.46 0 01.41 9.045 6.638 6.638 0 01.07 5.782a6.795 6.795 0 011.156-2.897A6.823 6.823 0 013.57.8C4.556.27 5.633 0 6.77 0a.75.75 0 01.733.593L8.68 6.086a.75.75 0 01-.203.688L6.466 8.785a19.741 19.741 0 008.749 8.75l2.011-2.012a.75.75 0 01.688-.203l5.493 1.177a.75.75 0 01.593.733 6.683 6.683 0 01-.8 3.2 6.796 6.796 0 01-4.983 3.499 6.662 6.662 0 01-.968.071zM6.17 1.533c-1.5.165-2.83.951-3.714 2.213a5.167 5.167 0 00-.636 4.787A22.748 22.748 0 0015.467 22.18a5.167 5.167 0 004.787-.636 5.194 5.194 0 002.213-3.714l-4.469-.958-2.1 2.1a.75.75 0 01-.85.15 21.236 21.236 0 01-10.17-10.17.75.75 0 01.15-.85l2.1-2.1-.958-4.47z","fill":"currentColor"}));
}

PhoneEmpty.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = PhoneEmpty;

PhoneEmpty.default = PhoneEmpty;
